import React, { Component } from "react";
import {
  MenuItem,
  Select as SpecialSelect,
  FormControl,
  InputLabel,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import { DatePicker } from "@material-ui/pickers";

import { v4 as uuidv4 } from "uuid";
import { Col, Form, FormGroup, Spinner, Button } from "react-bootstrap";

import {
  GetClusters,
  GetAreas,
  GetBranchByCode,
} from "../../../../store/actions/crdm_service_actions";

import {
  GetBranchCategoryOverallV4,
  GetBranchCategoryClusterV4,
  GetBranchCategoryAreaV4,
  GetBranchCategoryBranchV4,
} from "../../../../store/actions/reports-v4/branch_category_service_actions";
import {
  GetBranchCategoryOverall_v3,
  GetBranchCategoryCluster_v3,
  GetBranchCategoryArea_v3,
  GetBranchCategoryBranch_v3,
} from "../../../../store/actions/reports-v3/branch_category_service_actions";
import { connect } from "react-redux";
import moment from "moment";
import { closeModal } from "../../../../store/actions/ModalActions";
import { renderChartTitle } from "../../../../helpers/chartTitleBuilder";
import {
  moduleNames,
  OperationScope,
} from "../../../../helpers/dashboardModuleNames";
import { SetChartBranchCategoryTitle } from "../../../../store/actions/reports/chart_title_actions";
import AsyncSelect from "react-select/async";
import { toastr } from "react-redux-toastr";

const createData = (uuid, from, to) => {
  return { uuid, from, to };
};

const fromDate = new Date();
const toDate = new Date();

fromDate.setMonth(fromDate.getMonth());
toDate.setMonth(toDate.getMonth());

class BranchCategoryViewFilter extends Component {
  state = {
    clusters: [],
    areas: [],
    branches: [],

    isBusy: false,
    //date range
    isRunningBalance: false,
    from: fromDate,
    to: toDate,

    toView: "overall",
    previewText: "All Clusters",
    isClusterLoading: false,
    isAreaLoading: false,
    isBranchesLoading: false,

    clusterSelectContext: null,
    areaSelectContext: null,

    clusterId: null,
    areaId: null,

    clusterCode: null,
    areaCode: null,
  };

  componentDidMount() {
    this.openLoading();

    this.props.GetClusters().then((resp) => {
      if (resp.problem === null) {
        this.setState({ isClusterLoading: false, clusters: resp.data });
      }
    });

    this.props.GetAreas().then((resp) => {
      if (resp.problem === null) {
        this.setState({ isAreaLoading: false, areas: resp.data });
      }
    });

    this.closeLoading();
  }

  openLoading = () => {
    this.setState({ isClusterLoading: true, isAreaLoading: true });
  };
  closeLoading = () => {
    this.setState({ isClusterLoading: false, isAreaLoading: false });
  };

  handleCluster = (d) => {
    this.setState({
      clusterId: d.target.value.id,
      clusterSelectContext: d.target.value,
    });
  };

  handleArea = (d) => {
    this.setState({
      areaId: d.target.value.areaCode,
      areaSelectContext: d.target.value,
    });
  };

  createFilterDate = () => {
    let { dates } = this.state;
    dates.push(createData(uuidv4(), Date.now(), Date.now()));
    this.setState({ dates });
  };

  handleRadioChanged = (e) => {
    this.setState({
      toView: e.target.value,
      clusterId: null,
      areaId: null,
      areaSelectContext: null,
      clusterSelectContext: null,
    });

    switch (e.target.value) {
      case "clusters":
        this.setState({ previewText: "All Clusters" });
        break;

      case "areas":
        this.setState({ previewText: "All Areas" });
        break;

      default:
        this.setState({ previewText: "No Values" });
        break;
    }
  };

  handlebranchCode = (fieldData) => {
    this.setState({ branches: fieldData });
  };

  handleCoveredDate = (fieldData) => {
    this.setState({ date: fieldData });
  };

  handleFrom = (fieldData) => {
    this.setState({ from: fieldData });
  };

  handleTo = (fieldData) => {
    this.setState({ to: fieldData });
  };

  renderClusters = () => {
    return (
      <FormControl variant="outlined" fullWidth>
        <InputLabel id="demo-simple-select-outlined-label">Cluster</InputLabel>
        <SpecialSelect
          id="demo-simple-select-outlined"
          disabled={!this.state.toView === "clusters"}
          value={this.state.clusterSelectContext}
          onChange={this.handleCluster}
        >
          {this.state.clusters.map((data, key) => {
            return (
              <MenuItem value={data} key={key}>
                <span>{data.name} </span>
                <span className="text-danger ml-2 bold">{data.code}</span>
              </MenuItem>
            );
          })}
        </SpecialSelect>
      </FormControl>
    );
  };

  renderAreas = () => {
    return (
      <FormControl variant="outlined" fullWidth>
        <InputLabel id="demo-simple-select-outlined-label">Area</InputLabel>
        <SpecialSelect
          id="demo-simple-select-outlined"
          disabled={!this.state.toView === "clusters"}
          value={this.state.areaSelectContext}
          onChange={this.handleArea}
        >
          {this.state.areas.map((data, key) => {
            return (
              <MenuItem value={data} key={key}>
                {`${data.areaName}`}
                <span className="text-danger">({data.areaCode})</span>
              </MenuItem>
            );
          })}
        </SpecialSelect>
      </FormControl>
    );
  };

  PremiseGetBranchByCode = (code) => {
    return this.props.GetBranchByCode(code);
  };
  loadOptions = (inputValue, callback) => {
    // do some work

    if (inputValue.length >= 3) {
      this.PremiseGetBranchByCode(inputValue).then((resp) => {
        if (resp.problem === null) {
          if (resp.data && resp.data.length > 0) {
            const currentItem = resp.data[0];
            return callback([
              {
                label: `(${currentItem.branchCode}) ${currentItem.branchName}`,
                value: currentItem.branchCode,
              },
            ]);
          }

          return callback([]);
        }

        return callback([]);
      });
    } else {
      return callback([]);
    }
  };

  renderBranches = () => {
    return (
      <FormControl variant="filled" fullWidth>
        <AsyncSelect
          isMulti={true}
          placeholder="Enter Branch Codes"
          cacheOptions
          defaultOptions
          onChange={this.handlebranchCode}
          loadOptions={this.loadOptions}
        />
      </FormControl>
    );
  };

  renderFilterView = () => {
    switch (this.state.toView) {
      case "clusters":
        return this.renderClusters();

      case "areas":
        return this.renderAreas();

      case "branches":
        return this.renderBranches();

      default:
        return "";
    }
  };

  render() {
    return (
      <Form>
        <Form.Row>
          <FormGroup as={Col}>
            <FormControl className="d-inline">
              <RadioGroup
                row
                value={this.state.toView}
                onChange={this.handleRadioChanged}
              >
                <FormControlLabel
                  value="overall"
                  control={
                    <Radio
                      size="small"
                      color="primary"
                      value="overall"
                      name="radio-button"
                    />
                  }
                  label="Overall"
                />
                <FormControlLabel
                  value="clusters"
                  control={
                    <Radio
                      size="small"
                      color="primary"
                      value="clusters"
                      name="radio-button"
                    />
                  }
                  label="Clusters"
                />
                <FormControlLabel
                  value="areas"
                  control={
                    <Radio
                      size="small"
                      color="primary"
                      value="areas"
                      name="radio-button"
                    />
                  }
                  label="Areas"
                />
                <FormControlLabel
                  value="branches"
                  control={
                    <Radio
                      size="small"
                      color="primary"
                      value="branches"
                      name="radio-button"
                    />
                  }
                  label="Branches"
                />
              </RadioGroup>
            </FormControl>
          </FormGroup>
        </Form.Row>
        <Form.Row>
          <FormGroup as={Col}>
            <Form.Check
              style={{ zIndex: 0 }}
              id="isRunningBalance"
              checked={this.state.isRunningBalance}
              onChange={(e) => {
                this.setState({
                  isRunningBalance: e.target.checked,
                });
              }}
              className="float-right"
              type="switch"
              label="Specific period"
            />
          </FormGroup>
        </Form.Row>
        <Form.Row>
          <FormGroup as={Col}>{this.renderFilterView()}</FormGroup>
        </Form.Row>
        <Form.Row>
          {this.state.isRunningBalance ? (
            <>
              <FormGroup as={Col}>
                <DatePicker
                  disableToolbar
                  fullWidth
                  autoOk
                  disableFuture
                  label="From"
                  variant="inline"
                  inputVariant="outlined"
                  format="MMMM DD YYYY"
                  openTo="year"
                  views={["year", "month", "date"]}
                  showTodayButton
                  value={this.state.from}
                  onChange={this.handleFrom}
                />
              </FormGroup>

              <FormGroup as={Col}>
                <DatePicker
                  disableToolbar
                  fullWidth
                  autoOk
                  disableFuture
                  label="To"
                  variant="inline"
                  inputVariant="outlined"
                  format="MMMM DD YYYY"
                  openTo="year"
                  views={["year", "month", "date"]}
                  showTodayButton
                  value={this.state.to}
                  onChange={this.handleTo}
                />
              </FormGroup>
            </>
          ) : (
            <FormGroup as={Col}>
              <DatePicker
                disableToolbar
                fullWidth
                autoOk
                disableFuture
                label="Covered Date"
                variant="inline"
                inputVariant="outlined"
                format="MMMM DD YYYY"
                openTo="year"
                views={["year", "month", "date"]}
                showTodayButton
                value={this.state.date}
                onChange={this.handleCoveredDate}
              />
            </FormGroup>
          )}
        </Form.Row>
        <Form.Row>
          <FormGroup as={Col}>
            <Button
              disabled={this.state.isBusy}
              onClick={() => {
                this.setState({ isBusy: true });
                let { clusterId, areaId, isRunningBalance } = this.state;
                if (isRunningBalance) {
                  if (this.state.toView === "overall") {
                    this.PremiseGetDailyOverallBranchCategory().then(
                      (result) => {
                        if (result.problem === null && result.data !== null) {
                          this.props.Refresh();
                        } else {
                          this.setState({ isBusy: false });
                        }
                        closeModal();
                      }
                    );
                  }
                  if (this.state.toView === "clusters") {
                    if (clusterId !== null) {
                      this.PremiseGetDailyClusterBranchCategory(clusterId).then(
                        (result) => {
                          if (result.problem === null && result.data !== null) {
                            this.props.Refresh();
                          } else {
                            this.setState({ isBusy: false });
                          }

                          closeModal();
                        }
                      );
                    } else {
                      toastr.confirm(`Please specify a cluster to proceed.`, {
                        disableCancel: true,
                      });
                      this.setState({ isBusy: false });
                    }
                  }
                  if (this.state.toView === "areas") {
                    if (areaId !== null) {
                      this.PremiseGetDailyAreaBranchCategory(areaId).then(
                        (result) => {
                          if (result.problem === null && result.data !== null) {
                            this.props.Refresh();
                          } else {
                            this.setState({ isBusy: false });
                          }

                          closeModal();
                        }
                      );
                    } else {
                      toastr.confirm(`Please specify area to proceed.`, {
                        disableCancel: true,
                      });

                      this.setState({ isBusy: false });
                    }
                  }
                  if (this.state.toView === "branches") {
                    if (this.state.branches.length > 0) {
                      this.PremiseGetDailyBranchBranchCategory(
                        this.state.branches.map((item) => item.value)
                      ).then((result) => {
                        if (result.problem === null && result.data !== null) {
                          this.props.Refresh();
                        } else {
                          this.setState({ isBusy: false });
                        }
                        closeModal();
                      });
                    } else {
                      toastr.confirm(`Please specify a branch to proceed.`, {
                        disableCancel: true,
                      });
                      this.setState({ isBusy: false });
                    }
                  }
                } else {
                  if (this.state.toView === "overall") {
                    this.PremiseGetOverallBranchCategory().then((result) => {
                      if (result.problem === null && result.data !== null) {
                        this.props.Refresh();
                      } else {
                        this.setState({ isBusy: false });
                      }
                      closeModal();
                    });
                  }
                  if (this.state.toView === "clusters") {
                    if (clusterId !== null) {
                      this.PremiseGetClusterBranchCategory(clusterId).then(
                        (result) => {
                          if (result.problem === null && result.data !== null) {
                            this.props.Refresh();
                          } else {
                            this.setState({ isBusy: false });
                          }

                          closeModal();
                        }
                      );
                    } else {
                      toastr.confirm(`Please specify a cluster to proceed.`, {
                        disableCancel: true,
                      });
                      this.setState({ isBusy: false });
                    }
                  }
                  if (this.state.toView === "areas") {
                    if (areaId !== null) {
                      this.PremiseGetAreaBranchCategory(areaId).then(
                        (result) => {
                          if (result.problem === null && result.data !== null) {
                            this.props.Refresh();
                          } else {
                            this.setState({ isBusy: false });
                          }

                          closeModal();
                        }
                      );
                    } else {
                      toastr.confirm(`Please specify area to proceed.`, {
                        disableCancel: true,
                      });

                      this.setState({ isBusy: false });
                    }
                  }
                  if (this.state.toView === "branches") {
                    if (this.state.branches.length > 0) {
                      this.PremiseGetBranchBranchCategory(
                        this.state.branches.map((item) => item.value)
                      ).then((result) => {
                        if (result.problem === null && result.data !== null) {
                          this.props.Refresh();
                        } else {
                          this.setState({ isBusy: false });
                        }
                        closeModal();
                      });
                    } else {
                      toastr.confirm(`Please specify a branch to proceed.`, {
                        disableCancel: true,
                      });
                      this.setState({ isBusy: false });
                    }
                  }
                }
              }}
              className="mt-2 float-right"
            >
              {!this.state.isBusy ? (
                "View"
              ) : (
                <Spinner size="sm" animation="border" />
              )}
            </Button>
          </FormGroup>
        </Form.Row>
      </Form>
    );
  }

  getAssignedDates = () => {
    return {
      from: moment(this.state.from).format("YYYY-MM-DD"),
      to: moment(this.state.to).format("YYYY-MM-DD"),
    };
  };
  getAssignedDailyDates = () => {
    return {
      from: moment(this.state.from).format("YYYY-MM-DD"),
      to: moment(this.state.to).format("YYYY-MM-DD"),
    };
  };

  PremiseGetOverallBranchCategory = () => {
    var covered_date = this.state.date;

    var chartTitle = renderChartTitle(
      moduleNames.branchCategory,
      OperationScope.overall,
      moment(covered_date).format("MMMM DD YYYY"),
      moment(covered_date).format("MMMM DD YYYY"),
      null,
      null,
      null
    );
    this.props.SetChartBranchCategoryTitle(chartTitle);

    return this.props.GetBranchCategoryOverallV4({
      covered_date: covered_date,
      isRange: false,
    });
  };

  PremiseGetClusterBranchCategory = (clusterId) => {
    var covered_date = this.state.date;

    var chartTitle = renderChartTitle(
      moduleNames.branchCategory,
      OperationScope.specifiedCluster,
      moment(covered_date).format("MMMM DD YYYY"),
      moment(covered_date).format("MMMM DD YYYY"),
      `${this.state.clusterSelectContext.name} (${this.state.clusterSelectContext.code})`
    );
    this.props.SetChartBranchCategoryTitle(chartTitle);

    return this.props.GetBranchCategoryClusterV4({
      covered_date: covered_date,
      clusterId: clusterId,
      isRange: false,
    });
  };

  PremiseGetAreaBranchCategory = (areaId) => {
    var covered_date = this.state.date;

    var chartTitle = renderChartTitle(
      moduleNames.branchCategory,
      OperationScope.specifiedArea,
      moment(covered_date).format("MMMM DD YYYY"),
      moment(covered_date).format("MMMM DD YYYY"),
      null,
      `${this.state.areaSelectContext.areaName} (${this.state.areaSelectContext.areaCode})`
    );
    this.props.SetChartBranchCategoryTitle(chartTitle);

    return this.props.GetBranchCategoryAreaV4({
      covered_date: covered_date,
      areaId: areaId,
      isRange: false,
    });
  };

  PremiseGetBranchBranchCategory = (branch_codes) => {
    var covered_date = this.state.date;

    var chartTitle = renderChartTitle(
      moduleNames.branchCategory,
      OperationScope.specifiedBranch,
      moment(covered_date).format("MMMM DD YYYY"),
      moment(covered_date).format("MMMM DD YYYY"),
      null,
      null,
      `Branch (${branch_codes})`
    );
    this.props.SetChartBranchCategoryTitle(chartTitle);

    return this.props.GetBranchCategoryBranchV4({
      covered_date: covered_date,
      branch_codes: branch_codes,
      isRange: false,
    });
  };

  //Date Range
  PremiseGetDailyOverallBranchCategory = () => {
    var dates = this.getAssignedDailyDates();

    var chartTitle = renderChartTitle(
      moduleNames.branchCategory,
      OperationScope.overall,
      moment(dates.from).format("MMMM DD YYYY"),
      moment(dates.to).format("MMMM DD YYYY")
    );
    this.props.SetChartBranchCategoryTitle(chartTitle);

    return this.props.GetBranchCategoryOverallV4({
      dates: dates,
      isRange: true,
    });
  };

  PremiseGetDailyClusterBranchCategory = (clusterId) => {
    var dates = this.getAssignedDailyDates();

    var chartTitle = renderChartTitle(
      moduleNames.branchCategory,
      OperationScope.specifiedCluster,
      moment(dates.from).format("MMMM DD YYYY"),
      moment(dates.to).format("MMMM DD YYYY"),
      `${this.state.clusterSelectContext.name} (${this.state.clusterSelectContext.code})`,
      null
    );
    this.props.SetChartBranchCategoryTitle(chartTitle);

    return this.props.GetBranchCategoryClusterV4({
      dates: dates,
      clusterId: clusterId,
      isRange: true,
    });
  };

  PremiseGetDailyAreaBranchCategory = (areaId) => {
    var dates = this.getAssignedDailyDates();

    var chartTitle = renderChartTitle(
      moduleNames.branchCategory,
      OperationScope.specifiedArea,
      moment(dates.from).format("MMMM DD YYYY"),
      moment(dates.to).format("MMMM DD YYYY"),
      null,
      `${this.state.areaSelectContext.areaName} (${this.state.areaSelectContext.areaCode})`
    );
    this.props.SetChartBranchCategoryTitle(chartTitle);

    return this.props.GetBranchCategoryAreaV4({
      dates: dates,
      areaId: areaId,
      isRange: true,
    });
  };

  PremiseGetDailyBranchBranchCategory = (branch_codes) => {
    var dates = this.getAssignedDailyDates();

    var chartTitle = renderChartTitle(
      moduleNames.branchCategory,
      OperationScope.specifiedBranch,
      moment(dates.from).format("MMMM DD YYYY"),
      moment(dates.to).format("MMMM DD YYYY"),
      null,
      null,
      `Branch (${branch_codes})`
    );
    this.props.SetChartBranchCategoryTitle(chartTitle);

    return this.props.GetBranchCategoryBranchV4({
      dates: dates,
      branch_codes: branch_codes,
      isRange: true,
    });
  };
}

const mapStateToProps = (state) => {
  return {
    clusters: state.crdm.cluster,
    areas: state.crdm.area,
  };
};

const mapDispatchToProps = {
  GetClusters: GetClusters,
  GetAreas: GetAreas,
  SetChartBranchCategoryTitle: SetChartBranchCategoryTitle,
  GetBranchCategoryOverallV4: GetBranchCategoryOverallV4,
  GetBranchCategoryClusterV4: GetBranchCategoryClusterV4,
  GetBranchCategoryAreaV4: GetBranchCategoryAreaV4,
  GetBranchCategoryBranchV4: GetBranchCategoryBranchV4,
  GetBranchByCode: GetBranchByCode,

  GetBranchCategoryOverall_v3: GetBranchCategoryOverall_v3,
  GetBranchCategoryCluster_v3: GetBranchCategoryCluster_v3,
  GetBranchCategoryArea_v3: GetBranchCategoryArea_v3,
  GetBranchCategoryBranch_v3: GetBranchCategoryBranch_v3,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BranchCategoryViewFilter);
